export default __webpack_public_path__ + "static/traffic-police-hog-1b549012e1f75ee50a8be49fff72f40f.png";